module.exports = __webpack_public_path__ + "media/icons/marketplace@3x-7eede76d.png";